var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMoney(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#B7B7B7",
    fillRule: "evenodd",
    stroke: "#B2B2B2",
    strokeWidth: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.825 20.061H3.497A2 2 0 011.5 18.063V5.997A2 2 0 013.497 4h17.328c1.101 0 1.997.895 1.997 1.998v3.704h-1V5.998a1 1 0 00-.997-.999H3.497a1 1 0 00-.997.999v12.066c0 .551.447.998.997.998h17.328c.55 0 .997-.447.997-.998v-2.918h1v2.918a1.999 1.999 0 01-1.997 1.998"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.069 9.825c-.554 0-1.005.45-1.005 1.005v2.402c0 .554.45 1.005 1.005 1.005h4.809c.27 0 .492-.221.492-.492v-3.428a.493.493 0 00-.492-.492h-4.81zm4.809 5.412h-4.81c-1.104 0-2.004-.9-2.004-2.005V10.83c0-1.106.9-2.005 2.005-2.005h4.809c.823 0 1.492.669 1.492 1.492v3.428c0 .823-.67 1.492-1.492 1.492h0z"
  }))));
}
export default SvgIcMoney;